import React from "react";
//#region types
import { WintFormExpandableSectionEmptyContentProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ExpandableSectionEmptyContent: React.FC<WintFormExpandableSectionEmptyContentProps> = (props) => {
  const { children, title, subText } = props;

  return (
    <Grid item container className={cssExports.expandableForm}>
      <Grid
        item
        container
        className={clsx(cssExports.expansionPanel, cssExports.noContent)}
        alignItems="center"
        spacing={2}
        direction="row"
        justifyContent="space-between"
        flexWrap="nowrap"
      >
        <Grid container item direction="column" className={cssExports.expansionPanelSummaryContent}>
          <Grid item container>
            {title}
          </Grid>
          {subText && (
            <Grid item container className={cssExports.formControlDescription} alignItems="center">
              {subText}
            </Grid>
          )}
        </Grid>
        <Grid item>{children}</Grid>
      </Grid>
    </Grid>
  );
};

export default ExpandableSectionEmptyContent;
